<template>
  <div class="home">
    <div class="banner">
      <h2 style="margin:0;">Thank You！</h2>
      <h2>We have received your request.</h2>
    </div>
    <el-main>
      <div class="content">
        <p class="txt">We've analyzed your data and identified the optimal car insurance options for you.</p>
        <p class="txt fnotColor">Click on the offers below to see your quotes.</p>
        <div class="cart_list">
          <div class="cart">
            <div class="title">Coverage Professor</div>
            <div class="row">
              <div class="lf">
                <img src="@/assets/imgs/coverage-professor.svg" />
                <el-button class="link-btn"
                  @click="toLink('https://pentlyconger.com/b684e266-05ff-4571-ae3b-7eaa11bdcc33')"> View My Quote
                </el-button>
              </div>
              <div class="rg">
                <div class="p_txt"><i class="el-icon-check tips-icon" style="color:rgb(82, 178, 222);"></i>
                  <p> Comprehensive data analysis</p>
                </div>
                <div class="p_txt"><i class="el-icon-check tips-icon" style="color:rgb(82, 178, 222);"></i>
                  <p> Advanced predictive modeling</p>
                </div>
                <div class="p_txt"><i class="el-icon-check tips-icon" style="color:rgb(82, 178, 222);"></i>
                  <p> Actionable insights </p>
                </div>
              </div>
            </div>
          </div>
          <div class="cart">
            <div class="title">QuoteScan</div>
            <div class="row">
              <div class="lf">
                <img
                  src="data:image/png;base64,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" />
                <el-button class="link-btn"
                  @click="toLink('https://pentlyconger.com/1ecf0f4f-83a2-4257-b535-77ee7cdd3f99')"> View My Quote
                </el-button>
              </div>
              <div class="rg">
                <div class="p_txt"><i class="el-icon-check tips-icon"></i>
                  <p> User-friendly interface</p>
                </div>
                <div class="p_txt"><i class="el-icon-check tips-icon"></i>
                  <p> Accurate and reliable </p>
                </div>
                <div class="p_txt"><i class="el-icon-check tips-icon"></i>
                  <p> Real-time tracking</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <slideBar></slideBar>
  </div>
</template>

<script>
import { GetIP, GetIPadd } from '@/api/index'
export default {
  name: 'Result',
  components: {
  },
  data() {
    return {
      MyAdd: ''
    }
  },
  mounted() {
  },
  methods: {
    toLink(link) {
      window.open(link)
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/layout.scss";

.home {
  margin-top: 70px;
  background-color: rgb(246, 249, 254);

  .banner {
    background-image: url('../assets/imgs/banner3.webp');
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100px;
    padding: 100px 0px;
    text-align: center;

    h2 {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      line-height: 50px;
      font-size: 25px;
      color: rgba(255, 255, 255, 1);
    }
  }

  .el-main {
    padding: 0px;
    overflow: hidden;

    .content {
      width: 80%;
      margin: 20px auto;
      min-height: 550px;

      .txt {
        font-size: 24px;
        font-weight: 400;
        line-height: 2;
      }

      .txt.fnotColor {
        color: rgba(0, 189, 189, 1);
      }

      .cart_list {
        width: 100%;
        clear: both;
        display: flex;
        flex-wrap: wrap;
      }

      .cart {
        width: calc(50% - 5%);
        border-radius: 20px;
        background: rgb(255, 255, 255);
        box-shadow: 0px 0px 19px rgb(145, 211, 255, 0.4);
        margin: 20px 5% 20px 0px;

        .title {
          font-size: 20px;
          font-weight: 550;
          text-align: center;
          line-height: 2;
          margin-top: 20px;
          color: rgba(82, 178, 222, 1);
        }

        .row {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;

          .lf {
            width: 170px;
            text-align: center;

            img {
              width: 120px;
              margin-bottom: 10px;
            }

            padding: 10px 10px;
          }

          .rg {
            flex: 1;

            .p_txt {
              margin: 10px 0px;
              display: flex;

              .tips-icon {
                color: rgb(82, 178, 222);
                display: block;
                line-height: 1.5;
                margin-right: 5px;
              }

              p {
                font-size: 14px;
              }
            }

            padding: 0px 10px;
          }

          .link-btn {
            background: rgb(82, 178, 222);
            color: rgb(255, 255, 255);
          }

          .link-btn:hover,
          .link-btn:active {
            background: rgb(0, 189, 189);
            color: rgb(255, 255, 255);
          }
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .home {
    .banner {
      h2 {
        font-size: 20px;
      }
    }

    .el-main {
      .content {
        width: 89%;

        .txt {
          font-size: 20px;
        }

        .cart {
          width: calc(99% - 20px);
          float: none;
          margin: 10px;

          .row {
            flex-wrap: wrap;

            .lf,
            .rg {
              flex: 100%;
            }

            .lf {
              .el-button {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .home {
    margin-top: 76px;

    .banner {
      height: 120px;
      padding: 50px 0px;

      h2 {
        font-size: 20px;
      }
    }

    .el-main {
      .content {
        width: 94%;

        .txt {
          font-size: 16px;
        }

        .cart {
          width: calc(99% - 20px);
          float: none;
          margin: 10px;

          .row {
            flex-wrap: wrap;

            .lf,
            .rg {
              flex: 100%;
            }

            .lf {
              .el-button {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}</style>
